// Path: /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/pages/TermsOfUse.tsx
// Version: v2.1.0
// Description: Terms of Use page — Partners-style layout

import React from "react";
import { useBreakpoints } from "../hooks/Breakpoints.tsx";
import Container from "../hooks/Container.tsx";

const TermsOfUse: React.FC = () => {
  const { current } = useBreakpoints();
  const isDesktop = current === "desktop";
  const isTablet = current === "tablet";

  const titleSize = isDesktop ? "text-7xl" : isTablet ? "text-5xl" : "text-3xl";
  const h2Size = isDesktop ? "text-3xl" : isTablet ? "text-2xl" : "text-xl";
  const bodySize = isDesktop ? "text-lg" : isTablet ? "text-base" : "text-sm";

  return (
    <section className="bg-black text-white pt-[50px] pb-[50px] sm:pt-[75px] sm:pb-[75px] lg:pt-[100px] lg:pb-[100px]">
      <Container>
        <h1 className={`font-bold mb-16 ${titleSize}`}>Nutzungsbedingungen</h1>

        <div className="space-y-12">
          <div>
            <h2 className={`${h2Size} font-semibold mb-3`}>1. Geltungsbereich</h2>
            <div className="h-px bg-white/20 mb-4" />
            <p className={`${bodySize} text-white/80`}>
              Diese Nutzungsbedingungen gelten für die Nutzung der Website estata.com und aller zugehörigen
              Dienste der ESTATA GmbH. Mit der Nutzung dieser Website erklären Sie sich mit diesen
              Nutzungsbedingungen einverstanden.
            </p>
          </div>

          <div>
            <h2 className={`${h2Size} font-semibold mb-3`}>2. Urheberrecht</h2>
            <div className="h-px bg-white/20 mb-4" />
            <p className={`${bodySize} text-white/80`}>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem
              deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung
              außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen
              Autors bzw. Erstellers.
            </p>
          </div>

          <div>
            <h2 className={`${h2Size} font-semibold mb-3`}>3. Nutzung der Plattform MyEST</h2>
            <div className="h-px bg-white/20 mb-4" />
            <p className={`${bodySize} text-white/80`}>
              Für die Nutzung der Plattform MyEST gelten zusätzliche Nutzungsbedingungen, die bei der
              Registrierung akzeptiert werden müssen. Der Zugang zur Plattform ist nur registrierten
              Nutzern gestattet. Die Nutzung erfolgt auf eigene Verantwortung des jeweiligen Nutzers.
            </p>
          </div>

          <div>
            <h2 className={`${h2Size} font-semibold mb-3`}>4. Haftungsbeschränkung</h2>
            <div className="h-px bg-white/20 mb-4" />
            <p className={`${bodySize} text-white/80`}>
              Die ESTATA GmbH haftet nicht für Schäden, die durch die Nutzung oder Nichtnutzung der
              auf dieser Website angebotenen Informationen entstehen. Die Haftung für mittelbare und
              unmittelbare Schäden ist, soweit gesetzlich zulässig, ausgeschlossen. Dies gilt nicht
              für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit.
            </p>
          </div>

          <div>
            <h2 className={`${h2Size} font-semibold mb-3`}>5. Datenschutz</h2>
            <div className="h-px bg-white/20 mb-4" />
            <p className={`${bodySize} text-white/80`}>
              Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich.
              Soweit auf unseren Seiten personenbezogene Daten erhoben werden, erfolgt dies stets auf
              freiwilliger Basis. Weitere Informationen finden Sie in unserer Datenschutzerklärung.
            </p>
          </div>

          <div>
            <h2 className={`${h2Size} font-semibold mb-3`}>6. Anwendbares Recht</h2>
            <div className="h-px bg-white/20 mb-4" />
            <p className={`${bodySize} text-white/80`}>
              Es gilt das Recht der Bundesrepublik Deutschland. Gerichtsstand ist Berlin,
              soweit gesetzlich zulässig.
            </p>
          </div>
        </div>

        <div className="h-px bg-white/20 mt-16 mb-6" />
        <p className={`${bodySize} text-white/40`}>
          Stand: März 2026 · ESTATA GmbH, Katharinenstraße 9, 10711 Berlin
        </p>
      </Container>
    </section>
  );
};

export default TermsOfUse;
